import { onBeforeMount } from 'vue';

/**
 * Handles conditional filters reset
 * for list views based on the store's control flag.
 * * @param {object} store - The Pinia store instance (e.g., useStatementsStore())
 */
export function useFiltersReset(store) {
  if (!store || !('shouldResetFilters' in store)) {
    return;
  }

  const { shouldResetFilters, resetFilters, setAtomic } = store;

  async function executeResetLogic() {
    const shouldReset = shouldResetFilters;

    setAtomic('shouldResetFilters', true);

    if (shouldReset) {
      // Every store wired here defines resetFilters() as the correct action for a fresh visit:
      // narrow (search box only) for stores with sticky structured filters like status/date
      // range, full reset for stores without that distinction.
      resetFilters();
    }
  }

  onBeforeMount(() => {
    executeResetLogic();
  });
}
